import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        indicationPos: 0,
        headerClasses: []
    },
    mutations: {
        getIndicationPos(state, data) {
            state.indicationPos = data
        },
        setHeaderClasses(state, data) {
            state.headerClasses = []
            if (Array.isArray(data)) {
                data.every(c =>  state.headerClasses.push(c))
            } else {
                state.headerClasses.push(data)
            }
        }
    },
    actions: {
        getIndicationPos({commit}, data) {
            commit('getIndicationPos', data)
        },
        setHeaderClasses({commit}, data) {
            commit('setHeaderClasses', data)
        }
    },
    getters: {
        headerClasses: state => state.headerClasses
    }
})
